import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';

import {RouterModule} from "@angular/router";
import {Store} from "@softline/core";
import {SOFTLINE_FEATURE_TITLE, TitleStore} from "@softline/application";
import {SOFTLINE_FEATURE_WWS_WARENUEBERNAHME_LIEFERANT} from "@softapps/wws/warenuebernahme";
import {WwsLieferantStore} from "../../store/lieferant.store";

@Component({
    selector: 'soft-bestellung',
    imports: [RouterModule],
    templateUrl: './bestellung.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./bestellung.component.css']
})
export class BestellungComponent implements OnInit, OnDestroy {

  constructor(private store: Store) {}

  async ngOnInit(): Promise<void> {
    this.store.commit(
      SOFTLINE_FEATURE_TITLE,
      TitleStore.mutations.setSubTitle,
      '#WWS_WARENUEBERNAHME.UEBERSICHT.LABEL_BESTELLUNG_ABBUCHEN'
    );

    await this.store.dispatch(
      SOFTLINE_FEATURE_WWS_WARENUEBERNAHME_LIEFERANT,
      WwsLieferantStore.actions.loadMany
    );
  }

  ngOnDestroy(): void {
    this.store.commit(
      SOFTLINE_FEATURE_TITLE,
      TitleStore.mutations.setSubTitle,
      ''
    );
  }
}
